var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVectorIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 16,
    viewBox: "0 0 12 16",
    width: 12,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#35404f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m12 4.5v9.5c0 1.1046-.8954 2-2 2h-8c-1.104569 0-2-.8954-2-2v-12c0-1.10457.895431-2 2-2h5.5zm-3 0c-.82843 0-1.5-.67157-1.5-1.5v-2h-5.5c-.55228 0-1 .44772-1 1v12c0 .5523.44772 1 1 1h8c.5523 0 1-.4477 1-1v-9.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2.5 12.5c0-.2761.22386-.5.5-.5h3c.27614 0 .5.2239.5.5s-.22386.5-.5.5h-3c-.27614 0-.5-.2239-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2.5 10.5c0-.2761.22386-.5.5-.5h6c.27614 0 .5.2239.5.5s-.22386.5-.5.5h-6c-.27614 0-.5-.2239-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4.13868 6.79199 1.32947.88632 1.85507-1.85508c.07609-.07609.19234-.09495.28858-.04683l1.8882.97361v1.75c0 .27614-.22386.5-.5.5h-6c-.27614 0-.5-.22386-.5-.5v-.5s1.53952-1.27412 1.63868-1.20802z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4.25 6c.41421 0 .75-.33579.75-.75s-.33579-.75-.75-.75-.75.33579-.75.75.33579.75.75.75z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorIcon);
export default __webpack_public_path__ + "static/media/vector-icon.419b48bef2d9af21ced2d4b697c49095.svg";
export { ForwardRef as ReactComponent };